import { PricingContent } from "@/modules/billing/pricing/PricingPageContent";
import { getLandingLayout } from "@/modules/navigation/website-layout/LandingLayout";
import { NextPageWithLayout } from "./_app";
import { getWebsiteLayout } from "@/modules/navigation/website-layout/WebsiteLayout";
import { PageLayout } from "@/modules/navigation/website-layout/PageLayout";
import { PageTitle } from "@/lib/mui/PageTitle";
const Pricing: NextPageWithLayout = () => {
  return (
    <PageLayout>
      <PageTitle>Pricing</PageTitle>
      <article>
        <PricingContent />
      </article>
    </PageLayout>
  );
};

Pricing.getLayout = getWebsiteLayout;

export default Pricing;
